module.exports = __webpack_public_path__ + "static/img/far1.bf9106b7.png";